<template>
    <div class="content">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="card card-stats bg-danger">
              <div class="card-body  ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-hat-3 text-white"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers">
                      <p class="card-category ">Öğrenciler</p>
                      <p class="card-title text-white ">{{getStudents.length}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh "></i>
               
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="card card-stats bg-success">
              <div class="card-body ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-badge text-white"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers">
                      <p class="card-category ">Firmalar</p>
                      <p class="card-title text-white">{{getCompany.length}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh"></i>
               
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="card card-stats bg-info">
              <div class="card-body ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-single-copy-04 text-white"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers">
                      <p class="card-category">Süreç Takip</p>
                      <p class="card-title text-white">{{getSurecler.length}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh"></i>
                 
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="card card-stats bg-warning">
              <div class="card-body ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-watch-time text-white"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers ">
                      <p class="card-category">Randevu</p>
                      <p class="card-title text-white ">0</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh"></i>
                
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <hr>
        <br>
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="card card-stats">
              <div class="card-body ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-circle-10 text-warning"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers">
                      <p class="card-category text-dark">Toplam Kontenjan</p>
                      <p class="card-title text-dark">{{getsayikontenjan}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="card card-stats">
              <div class="card-body ">
                <div class="row">
                  <div class="col-5 col-md-4">
                    <div class="icon-big text-center icon-warning">
                      <i class="nc-icon nc-circle-10 text-warning"></i>
                    </div>
                  </div>
                  <div class="col-7 col-md-8">
                    <div class="numbers">
                      <p class="card-category text-dark">Boş Kontenjan</p>
                      <p class="card-title text-dark">{{getsayiboskontenjan}}</p><p>
                    </p></div>
                  </div>
                </div>
              </div>
              <div class="card-footer ">
                <hr>
                <div class="stats">
                  <i class="fa fa-refresh"></i>
            
                </div>
              </div>
            </div>
          </div>
        </div>
        <br>
        <hr>
        <br>
        <div class="row">
          <div class="col-md-3">
            <div class="card bg-danger ">
            <div class="card-body ">
              <div class="row">
                <div class="col text-white">MEDİKAL</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
              
            </div>
          </div>
          </div>
          <div class="col-md-3 ">
            <div class="card bg-warning ">
            <div class="card-body">
              <div class="row">
                <div class="col text-white">SAVUNMA</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-3">
            <div class="card bg-success">
            <div class="card-body">
              <div class="row">
                <div class="col text-white">MAKİNE</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-3">
            <div class="card bg-secondary">
            <div class="card-body">
             <div class="row">
                <div class="col text-white">E.ELEKTRONİK</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>


        </div>
        <div class="row">
          <div class="col-md-3">
            <div class="card bg-secondary ">
            <div class="card-body">
              <div class="row ">
                <div class="col text-white">REKLAM TASARIM</div>
              <div class="col-3 text-white numbers ">15</div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-3 ">
            <div class="card bg-success ">
            <div class="card-body">
              <div class="row">
                <div class="col text-white">MİMARLIK</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-3">
            <div class="card bg-warning">
            <div class="card-body ">
              <div class="row">
                <div class="col text-white">YAZILIM</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-md-3">
            <div class="card bg-danger">
            <div class="card-body">
              <div class="row">
                <div class="col text-white">DİĞER</div>
              <div class="col-3 text-white numbers">15</div>
              </div>
            </div>
          </div>
          </div>


        </div>
      </div>
</template>

<script>

import { mapGetters} from "vuex";

export default {
    computed : {
      ...mapGetters(["getSurecler","getStudents","getCompany","getsayikontenjan","getsayiboskontenjan"])
    },
       data: function () {
      return {
     
    }
  },
  methods : {
 
  
  }

}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard.vue